import { isSystem, lang, isLang } from '@umu/ukit-lang';
import { Checkbox } from 'common/src/components';
import './serviceAgreement.scss';

interface IProps {
    isChecked: boolean;
    onChange: (isChecked: boolean) => void;
}

let link = '';
if (isSystem('CN')) {
    link = 'https://www.umu.cn/staticPage/termcondition.html';
} else if (isSystem('EN')) {
    link = 'https://www.umu.com/staticPage/termcondition.html';
} else if (isSystem('EM')) {
    link = 'https://www.umu.io/staticPage/termcondition.html';
} else if (isSystem('JP')) {
    link = 'https://www.umu.co/staticPage/umu-terms-of-service-for-enterprise.html';
} else if (isSystem('TW')) {
    link = 'https://www.umu.tw/staticPage/termcondition.html';
}

export function ServiceAgreement(props: IProps) {
    const { onChange, isChecked } = props;
    return (
        <div className="service-agreement">
            <Checkbox isChecked={isChecked} onChange={onChange} disabledCheck={false}></Checkbox>
            <div className="agreement-content">
                {isLang('EN') ? '' : lang('我同意')}
                <a href={link} target="blank">
                    {lang('《UMU付费服务条款》')}
                </a>
            </div>
        </div>
    );
}
